module.exports = __webpack_public_path__ + "static/media/stock-profile.39eb0bbf.jpg";